import ChronologicalOrderedEvents from './chronologicalOrderedEvents';

export default ChronologicalOrderedEvents;
